import React from "react";
import {Icon} from "bloomer";

interface IProgressStepProps {
    failed: boolean;
    finished: boolean;
    inProgress: boolean;
    text: string;
    errorMessage: string;
}

class ProgressStep extends React.Component<IProgressStepProps, {}> {
    constructor(props: IProgressStepProps) {
        super(props);
    }

    public render() {
        let color;
        let futureTask = false;
        if (this.props.failed) {
            color = 'black';
        } else if (this.props.finished) {
            color = 'green';
        } else if (this.props.inProgress) {
            color = 'black';
        } else {
            futureTask = true;
        }

        return <div style={{
            display: 'flex'
        }}>
            <div style={{
                width: '32px'
            }}>
                {
                    this.props.inProgress ? <Icon className="fas fa-spinner fa-spin"/>
                        : (this.props.finished ? <Icon style={{color: 'green'}} className="fas fa-check"/>
                        : (this.props.failed ? <Icon style={{color: 'red'}} className="fas fa-times"/>
                            : (futureTask ? <Icon className="fas fa-angle-right" style={{opacity: 0.5}}/> : <></>)))
                }
            </div>
            <div style={{
                flex: 1
            }}>
                <span style={{
                    color,
                    opacity: futureTask ? 0.5 : 1
                }}>{this.props.text}</span>
                {
                    this.props.failed && this.props.errorMessage ? <div style={{
                        color: 'red',
                        marginLeft: '15px'
                    }}>{this.props.errorMessage}</div> : <></>
                }
            </div>
        </div>;
    }
}

export default ProgressStep;


// WEBPACK FOOTER //
// ./src/components/model/CrossProvider/ProgressStep.tsx